<template>
  <q-avatar
    :icon="iconName"
    :size="props.size"
    class="re-avatar"
    :class="[`re-avatar--${props.color}`]"
  />
</template>
<script setup>
import { computed } from 'vue'

import enums from '@/plugins/enums'

const props = defineProps({
  color: {
    type: String,
    validator(value) {
      // The value must match one of these strings
      return [
        enums.feedbackType.POSITIVE,
        enums.feedbackType.WARNING,
        enums.feedbackType.NEGATIVE,
        enums.feedbackType.INFO,
        enums.feedbackType.PRIMARY,
      ].includes(value)
    },
    default: enums.feedbackType.INFO,
  },
  size: {
    type: String,
    default: 'xl',
  },
  icon: {
    type: String,
    required: false,
    default: undefined,
  },
})

const iconName = computed(() => {
  if (props.icon) {
    return props.icon
  }

  return {
    positive: 'mdi-check',
    warning: 'mdi-alert-outline',
    negative: 'mdi-alert-octagon',
    info: 'mdi-lightbulb-outline',
    primary: 'mdi-lightbulb-outline',
  }[props.color]
})
</script>

<style scoped lang="scss">
.re-avatar {
  align-self: center !important;

  &--positive {
    background-color: $positive-border;

    :deep(.q-icon) {
      color: $positive;
    }
  }

  &--primary {
    background-color: var(--primary-light) !important;

    :deep(.q-icon) {
      color: var(--q-primary);
    }
  }

  &--info {
    background-color: var(--info-border) !important;

    :deep(.q-icon) {
      color: var(--q-info);
    }
  }

  &--warning {
    background-color: var(--warning-border);

    :deep(.q-icon) {
      color: $warning;
    }
  }

  &--negative {
    background-color: $negative-light;

    :deep(.q-icon) {
      color: $negative;
    }
  }
}
</style>
